export const FORM = `{
  id
  data
  partner_id
  status
  form_source
  ref_link
  lastUpdatedBy
  createdAt
  updatedAt
}`

export const createForm = /* GraphQL */ `
  mutation CreateForm(
    $input: CreateFormInput!
    $condition: ModelFormConditionInput
  ) {
    createForm(input: $input, condition: $condition) ${FORM}
  }
`

// Experimente: Exposure der LP (public IAM create)
export const createExperimentExposure = /* GraphQL */ `
  mutation CreateExperimentExposure($input: CreateExperimentExposureInput!) {
    createExperimentExposure(input: $input) {
      id
    }
  }
`
